/** Layer 1 — four drifting radial blobs + the spinning conic echo of the orb.
    All opacities are orb-state driven via CSS variables on .am-screen. */
export function AmbientLayer() {
	return (
		<div className="am-ambient" aria-hidden="true">
			<div className="am-blob am-blob-1" />
			<div className="am-blob am-blob-2" />
			<div className="am-blob am-blob-3" />
			<div className="am-blob am-blob-4" />
			<div className="am-echo" />
		</div>
	)
}
